// src/App.jsx
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AllProducts from "./pages/AllProducts";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { CartProvider } from "./context/CartContext";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Home from "./pages/Home";
import ChangePassword from "./pages/ChangePassword";
import Contact from "./pages/Contact";
import Orders from "./pages/Orders";
import { Toaster } from "react-hot-toast";
import About from "./pages/About";
const Dashboard = () => (
  <div className="flex justify-center items-center min-h-screen">
    <h1 className="text-2xl font-bold">Welcome to Dashboard</h1>
  </div>
);

const App = () => {
  return (
    <AuthProvider>
      <CartProvider>
      <Router>
         <Toaster position="top-center" />
        <Navbar/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/products" element={<AllProducts/>} />
          <Route path="/product/:id" element={<ProductDetails />} />
           <Route path="/cart" element={<Cart />} />
           <Route path="/contact" element={<Contact />} />
           <Route path="/about" element={<About />} />

           <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
           <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
           <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />



        </Routes>
        <Footer/>
      </Router>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;
